module.exports = __webpack_public_path__ + "static/media/Jasper_Chen_Resume.093b9f63.pdf";